export default "__VITE_PUBLIC_ASSET__9c6a092a__"